import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsLuminaryModel {
  id: string;
  title: string;
  markerPopupText: string;
  assetId: string;
  operator: string;
  elementIdentification: number;
  lampType: string;
  dimmingStatus: string;
  controlProgramName: string;
  monitoringProgramName: string;
  alarmProgramName: string;
  status: string;
  associatedTelecellId: number;
  icon: Icon;
}

export class LuminaryModel extends MarkerModelBase {
  static className = 'LuminaryModel';
  classProperties: IPropsLuminaryModel;

  constructor(props: IPropsLuminaryModel, geometry: IGeometryModel) {
    super(geometry, LuminaryModel.className);
    this.classProperties = props;
  }
}

